// 8.3.11 Video Moments UI (merged as `vm`).
const vm = {
 "label": "Une situation pour toi",
 "play": "Lire",
 "pause": "Pause",
 "replay": "Revoir",
 "showTranscript": "Voir la transcription",
 "hideTranscript": "Masquer la transcription",
 "showMeaning": "Voir le sens",
 "hideMeaning": "Masquer le sens",
 "whatWouldYouSay": "Qu'est-ce que tu dirais ?",
 "placeholder": "Écris ta réponse en {lang}",
 "respond": "Répondre",
 "natural": "C'est naturel.",
 "better": "Une façon plus naturelle pourrait être :",
 "savePhrase": "Enregistrer",
 "saved": "Enregistrée",
 "usefulPhrases": "Expressions utiles",
 "continueFriend": "Continuer dans Fluent Friend",
 "openInterview": "T'entraîner à un entretien complet",
 "startMission": "Commencer la mission",
 "videoFailed": "La vidéo n'a pas pu se charger — tu peux quand même lire la scène et répondre.",
 "respondFailed": "Impossible d'envoyer. Réessaie.",
 "retryVideo": "Réessayer la vidéo",
 "recommendedLevel": "Niveau recommandé",
 "video": "Scène vidéo",
 "titles": {"vm_cafe_es": "Commander au café", "vm_hotel_fr": "Réception de l'hôtel", "vm_meet_de": "Rencontrer quelqu'un", "vm_interview_ar": "Début d'un entretien d'embauche", "vm_directions_sr": "Demander son chemin", "vm_disagree_sr": "Un petit désaccord"},
 "roles": {"waitress": "serveuse", "customer": "client", "receptionist": "réceptionniste", "guest": "client de l'hôtel", "interviewer": "recruteur", "candidate": "candidat", "tourist": "touriste", "passer-by": "passante"}
};
export default vm;
